export default "__VITE_ASSET__qfGHIwIV__"